import React from 'react';
import SettingsContainer from '@dashboard/components/SettingsContainer';
import SettingsHeader from '@dashboard/components/SettingsHeader';
import { Form } from '@dashboard/components/Formik';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import useSellerQueries from '@dashboard/hooks/queries/useSellerQueries';
import SettingsDescription from '@dashboard/components/SettingsDescription';

const SettingsInvoices = () => {
  const { seller } = useAuth();
  const { updateSeller } = useSellerQueries();

  return (
    <SettingsContainer size="xl">
      <SettingsHeader id="invoices">Invoices</SettingsHeader>
      <SettingsDescription className="mb-4">
        Automatically generate invoices for one-time payments and event tickets, and attach them to
        payment confirmation emails.
      </SettingsDescription>

      <div className="my-4 max-w-lg">
        <Form
          enableReinitialize
          initialValues={{
            invoicing: seller.invoicing,
            bankDetails: seller.bankDetails,
          }}
          fields={({ values }) => [
            {
              name: 'invoicing.enabled',
              required: false,
              type: 'checkbox',
              label: 'Enable invoices',
              tooltip: 'Automatically generate invoices for one-time payments and event tickets',
              reduceMargin: values.invoicing?.enabled,
            },
            {
              name: 'invoicing.dueDays',
              required: false,
              type: 'number',
              label: 'Invoice due days',
              tooltip:
                'For invoices with an outstanding balance, the number of days due from the invoice creation date.',
              hidden: !values.invoicing?.enabled,
              inset: true,
            },
            {
              name: 'invoicing.attachInvoicesToEmails',
              required: false,
              type: 'checkbox',
              label: 'Attach invoices to payment confirmation emails',
              hidden: !values.invoicing?.enabled,
              reduceMargin: true,
              inset: true,
            },
            {
              name: 'invoicing.attachInvoicesToNotificationEmails',
              required: false,
              type: 'checkbox',
              label: 'Attach invoices to payment notification emails',
              hidden: !values.invoicing?.enabled,
              inset: true,
            },
            {
              name: 'bankDetails',
              required: false,
              type: 'textarea',
              label: 'Invoice bank details',
              tooltip: 'Bank details will be displayed on invoices with an outstanding balance.',
              hidden: !values.invoicing?.enabled,
              inset: true,
            },
            {
              name: 'invoicing.additionalInformation.enabled',
              type: 'checkbox',
              label: 'Add additional information to invoices',
              hidden: !values.invoicing?.enabled,
              inset: true,
            },
            {
              type: 'fieldgroup',
              hidden: !values.invoicing?.additionalInformation?.enabled,
              noMargin: false,
              fields: [
                {
                  name: 'invoicing.additionalInformation.title',
                  required: false,
                  type: 'text',
                  label: 'Additional information title',
                  inset: true,
                },
                {
                  name: 'invoicing.additionalInformation.message',
                  required: false,
                  type: 'textarea',
                  label: 'Additional information message',
                  inset: true,
                },
              ],
            },
          ]}
          onSubmit={async values => {
            try {
              const { data } = await updateSeller(values);

              return {
                data,
              };
            } catch (error) {
              return {
                error,
              };
            }
          }}
        />
      </div>
    </SettingsContainer>
  );
};

export default SettingsInvoices;
